import styled, { css } from 'styled-components'
import { getAutomatedStyleProp } from '../../providers/ComponentsThemeProvider'

export const Container = styled.div<{ $small?: boolean }>`
  font-size: var(--font-size-400);
  font-weight: var(--font-weight-regular);
  color: ${getAutomatedStyleProp('colorOnBackground', 'var(--text-primary)')};

  ${({ $small }) =>
    $small &&
    css`
      font-size: var(--font-size-300);
    `}
`

export const ItemContainer = styled.div<{ bold?: boolean; highlighted?: boolean }>`
  display: flex;

  & + & {
    margin-top: var(--space-200);
  }

  ${({ bold }) =>
    bold &&
    css`
      font-weight: var(--font-weight-semibold);
    `}

  ${({ highlighted }) =>
    highlighted &&
    css`
      color: var(--text-brand);
    `}
`

export const ItemLabel = styled.div`
  flex: 1;
`

export const ItemLabelWithIcon = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
`

export const ItemLabeLIcon = styled.div`
  margin-left: var(--space-200);
`
